// Customer Analysis API endpoints

export const getCustomerAnalysisUrl = (): string => {
  return "/api/customers/analysis";
};
